import React from "react";
import styled from "styled-components";
import { ACTIVE, INACTIVE } from "../../constants/OptionsConstants";
import OptionSelectComponent from "../../components/Generic/OptionSelectComponent";
import DownloadButton from "../../components/Generic/DownloadButton";

const LinksOptionsLine = ({ linksType, setLinksType, downloadCSV }) => {
  const OPTIONS_LIST = [
    {
      text: "Active",
      value: ACTIVE,
    },
    {
      text: "Inactive",
      value: INACTIVE,
    },
  ];

  return (
    <Container>
      <OptionSelectComponent
        optionsList={OPTIONS_LIST}
        selectedOption={linksType}
        setSelectedOption={setLinksType}
      />

      <DownloadButton downloadCSV={downloadCSV} />
    </Container>
  );
};

export default LinksOptionsLine;
const Container = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
`;
